export default "__VITE_ASSET__CwzNLWVJ__"